import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageTitleService } from 'app/services/page-title/page-title.service';
import { Routenames } from '../route-names.enum';
import { AuthService } from '../services/auth/auth.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false,
})
export class LogoutComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private router: Router,
        private pageTitleService: PageTitleService
    ) {}

    ngOnInit(): void {
        this.pageTitleService.setTitle('Uitloggen');

        this.authService.logout().subscribe(
            () => this.router.navigate([Routenames.login], { replaceUrl: true }),
            () => this.router.navigate([Routenames.login], { replaceUrl: true })
        );
    }
}
